import {TAppDispatch} from 'core/redux/types';
import {useDispatch} from 'react-redux';

export const useAppDispatch = (): TAppDispatch => useDispatch<TAppDispatch>();
